module.exports = __webpack_public_path__ + "static/media/telegram.346215a0.svg";